import React from 'react';
import { Grid } from '@mui/material';

import { useSettings } from 'app/main/components';
import { ModuleSearchField } from 'app/main/components/fields';
import { InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import { type OrdersLinesEditDialogSection } from '../OrdersLinesEditDialog';

export default function OrdersLinesEditDialogProjectSection(props: OrdersLinesEditDialogSection) {
	const { t } = useSettings();

	return (
		<>
			<InlineTitle text="ORDERS_LINES_EDIT_DIALOG_PROJECT_SECTION" />
			<Grid size={12}>
				<ModuleSearchField
					name="orli_proj_uid"
					label={t('DETAILS_ORDERS_LINES_FIELD_PROJECT')}
					module="projects"
					uid={props.model.orli_proj_uid}
					isEdit={props.canEdit}
					sendChange={props.sendChange}
				/>
			</Grid>
		</>
	);
}
